/** @jsxImportSource @emotion/react */
"use client";

import { createFullscreenModal } from "../../../modals/FullscreenModalModal/FullscreenModalModal.emotion";
import type { CampaignSupportFormProps } from "./CampaignSupportForm.emotion";
import { CampaignSupportForm } from "./CampaignSupportForm.emotion";

export type CampaignSupportModalProps = CampaignSupportFormProps;

export const CampaignSupportModal = createFullscreenModal(
  (props: CampaignSupportModalProps) => <CampaignSupportForm {...props} />,
);
